<template>
  <div
    class="tooltip"
    @mouseleave="onMouseLeave"
    @mouseover="onMouseover"
    :class="{'tooltip_left': left, 'tooltip_colorized': orange}">
    <icon-base
      :class="{'tooltip__icon_white': isWhite}"
      class="tooltip__icon" :white="isWhite" :red="!isWhite && !orange" :orange="orange">
      <icon-question/>
    </icon-base>
    <div class="tooltip__message">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconQuestion from '../icons/IconQuestion';

export default {
  data: () => ({
    tooltipOpen: false,
  }),
  props: {
    left: Boolean,
    orange: Boolean,
  },
  components: {
    IconQuestion,
  },
  computed: {
    isWhite() {
      return this.tooltipOpen;
    },
  },
  methods: {
    onMouseover() {
      if (this.tooltipOpen) {
        return;
      }
      this.$emit('mouseover');
      this.tooltipOpen = true;
    },
    onMouseLeave() {
      this.tooltipOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .tooltip {
    position: relative;
    height: 16px;
    max-width: 16px;
    $zindex: 90;
    &__message {
      display: none;
      position: absolute;
      bottom: -19px;
      left: -20px;
      width: 275px;
      background: $red-color3;
      box-shadow: 12px 12px 30px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      @include font(14px, $white-color2);
      font-weight: 600;
      font-size: 12px;
      line-height: 19px;
      padding: 20px 20px 54px;
      z-index: $zindex;
    }
    &_push-notifications {
      .tooltip__message {
        padding: 20px 19px 53px;
        bottom: -18px;
      }
    }
    &:hover {
      max-width: 275px;
      .tooltip__icon {
        position: relative;
        z-index: $zindex + 1;
      }
      .tooltip__message {
        display: block;
      }
      .icon-question {
        z-index: 2;
      }
    }
    &_left {
      .tooltip__message {
        bottom: -20px;
        left: -239px;
        padding: 15px 19px 54px;
      }
    }
    &_colorized {
      .tooltip__message {
        color: $grey-color2;
        background: $grey-color6;
      }
    }
  }
  .icon-question {
    position: relative;
    cursor: pointer;
  }
  @media only screen and (max-width : 458px) {
    .fields {
      .tooltip {
        position: static;
        &__icon_white {
          display: none;
        }
        &__message {
          position: absolute;
          left: 0px;
          bottom: auto;
          right: 0;
          margin: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/Tooltip.vue